var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 675.26 676.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #7699c4;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: none;\n        stroke: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "fourInOne",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "four-chamber bg",
    d: "M612.58,613.24H62.68V63.35h549.89v549.89h.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "one-chamber bg",
    points: "63.68 64.33 338.49 339.14 64.55 613.08 63.68 64.33"
  }), /*#__PURE__*/React.createElement("g", {
    id: "outline"
  }, /*#__PURE__*/React.createElement("g", {
    className: "top"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 360.56,
    y1: 230.18,
    x2: 360.56,
    y2: 96.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "364.65 100.21 363.92 100.89 360.56 97.28 357.2 100.89 356.47 100.21 360.56 95.81 364.65 100.21"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 313.2,
    y1: 230.18,
    x2: 313.2,
    y2: 96.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "317.29 100.21 316.56 100.89 313.2 97.28 309.85 100.89 309.11 100.21 313.2 95.81 317.29 100.21"
  })), /*#__PURE__*/React.createElement("g", {
    className: "bottom"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 360.56,
    y1: 426.98,
    x2: 360.56,
    y2: 576.86
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "356.47 573.55 357.2 572.86 360.56 576.48 363.92 572.86 364.65 573.55 360.56 577.94 356.47 573.55"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 313.2,
    y1: 426.98,
    x2: 313.2,
    y2: 576.86
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "309.11 573.55 309.84 572.86 313.2 576.48 316.56 572.86 317.29 573.55 313.2 577.94 309.11 573.55"
  })), /*#__PURE__*/React.createElement("g", {
    className: "left"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 238.03,
    y1: 311.93,
    x2: 95.63,
    y2: 311.93
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "98.95 307.84 99.63 308.58 96.02 311.93 99.63 315.29 98.95 316.02 94.55 311.93 98.95 307.84"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 238.03,
    y1: 359.29,
    x2: 95.63,
    y2: 359.29
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "98.95 355.2 99.63 355.93 96.02 359.29 99.63 362.65 98.95 363.38 94.55 359.29 98.95 355.2"
  })), /*#__PURE__*/React.createElement("g", {
    className: "right"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 446.97,
    y1: 311.93,
    x2: 575.6,
    y2: 311.93
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "572.28 316.02 571.6 315.29 575.21 311.94 571.6 308.58 572.28 307.85 576.68 311.94 572.28 316.02"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 446.97,
    y1: 359.29,
    x2: 575.6,
    y2: 359.29
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "572.28 363.38 571.6 362.65 575.21 359.29 571.6 355.94 572.28 355.2 576.68 359.29 572.28 363.38"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M612.58,613.22H62.68V63.33h549.89v549.89h.01ZM63.69,612.22h547.89V64.33H63.68v547.89h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 477.73,
    y: 289.58,
    width: 1,
    height: 378.59,
    transform: "translate(-198.54 478.42) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 200.33,
    y: 6.81,
    width: 1,
    height: 389.34,
    transform: "translate(-83.65 201.02) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 8.85,
    y: 481.07,
    width: 370.98,
    height: 1,
    transform: "translate(-283.6 278.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 290.35,
    y: 196.59,
    width: 376.94,
    height: 1,
    transform: "translate(.88 396.3) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.68,383.94H0v-91.34h63.68v91.34ZM1,382.94h61.68v-89.34H1v89.34Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.5,
    y: 337.77,
    width: 62.68,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M675.26,383.94h-63.68v-91.34h63.68v91.34ZM612.58,382.94h61.68v-89.34h-61.68v89.34Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 612.08,
    y: 337.77,
    width: 62.68,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M383.3,63.68h-91.34V0h91.34v63.68ZM292.96,62.68h89.34V1h-89.34v61.68Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 337.13,
    y: 0.5,
    width: 1,
    height: 62.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M383.3,676.6h-91.34v-63.68h91.34v63.68ZM292.96,675.6h89.34v-61.68h-89.34v61.68Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 337.13,
    y: 613.42,
    width: 1,
    height: 62.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 337.63,
    cy: 338.27,
    r: 30.38
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModes);
export default __webpack_public_path__ + "static/media/modes.a2394e6ef35d2632bc62a0a2557d1704.svg";
export { ForwardRef as ReactComponent };